<c-card *transloco="let t">
  <c-card-body class="px-2">

      <c-row>
        <c-col class="col-lg-6 col-12">
          <h1>{{ t('Groups') }}</h1>
        </c-col>
        <c-col class="col-lg-6 col-12 text-end justify-content-end">

              <div class="btn-group mb-2 " role="group">
                <button *ngIf="okService.hasMonitorAccess('groups','create')" class="btn btn-success text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                  <i class="fa-solid fa-plus"></i>  {{ t('Create a Group') }}
                </button>
                <div class="btn-group" *ngIf="okService.isAdmin()">
                  <button type="button" class="btn btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Import/Export Groups') }}
                  </button>
                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item" routerLink="/mgmt/groups/groups-upload"><i class="fa-solid fa-cloud-arrow-up"></i> {{ t('Upload Groups') }}</a></li>
                      <li><a class="dropdown-item"  (click)="export()"><i class="fa-solid fa-file-excel"></i> {{ t('Export Groups') }}</a></li>
                    </ul>
                </div>
                <a class="btn btn-primary" href="https://okalone.zendesk.com/hc/en-gb/articles/35907728972817-Instructions-for-Creating-Worker-Groups" role="button" target="_new"><i class="fa-regular fa-circle-question"></i> {{ t('Help') }}</a>
              </div>

        </c-col>
      </c-row>
      <c-row>
        <c-col class="col-12">
          <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="!okService.isDismissed('groups_info')">
            <i class="fa-solid fa-circle-info"></i> {{ t('Groups can be used to help manage your workers. Groups can be set up with their own monitors, check in frequency and contact methods. Then all workers added to the group can have their setting synchronized. Groups are great for workers in the same location or who need the same monitors responding.') }}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="okService.doDismiss('groups_info')"></button>
          </div>
        </c-col>
      </c-row>

        <c-row class="row-md-6">

          <div class="collapse" id="collapseExample">
            <div class="card m-3">
              <div class="card-header">
                <h3>{{ t('Create a New Group') }}</h3>
              </div>
              <div class="card-body">
              <p>{{ t('Enter the name of the group you wish to create.') }}</p>
              <form [formGroup]="nameFormGroup" cForm (ngSubmit)="submitForm()">
                <div class="form-group row mb-2" >
                  <label class="col-sm-4 col-form-label text-end"><svg cIcon name="cilGrain"></svg> {{ t('Group Name') }}</label>
                  <div class="col-sm-8">
                    <input
                      [formControlName]="'name'"
                      cFormControl
                      placeholder="{{ t('Group Name')}}"
                      [ngClass]="{ 'border-danger': submitted && f['name'].errors }"
                    />
                    <div *ngIf="submitted && f['name'].errors && f['name'].errors['invalid']" class="invalid-feedback">
                      {{ f['name'].errors['invalid'] }}
                    </div>
                    <div *ngIf="submitted && f['name'].errors && f['name'].errors['required']" class="invalid-feedback">
                      {{ t('A valid name is required') }}
                    </div>
                  </div>
                </div>

                <button cButton class="btn btn-primary text-white my-2" type="submit"><i class="fa-solid fa-check"></i> {{ t('Create Group Now') }}</button>

              </form>
            </div>
            </div>
          </div>

        </c-row>

        <c-row>
          <c-col class="col-12 col-lg-6">

                <form cForm class="row row-cols-lg-auto g-2 align-items-center" [formGroup]="formGroup" (ngSubmit)="updateFilter()">
                  <c-col class="col-sm-6">
                    <label cLabel class="visually-hidden" for="search">
                      {{ t('Search') }}
                    </label>
                    <c-input-group class="me-2 mb-2">
                      <span cInputGroupText><svg cIcon name="cil-search"></svg></span>
                      <input cFormControl id="search" formControlName="search" placeholder="{{ t('Search') }}" />
                    </c-input-group>
                  </c-col>

                  <c-col xs="auto">
                    <button cButton class="btn btn-light me-2 mb-2" type="submit"><i class="fa-solid fa-magnifying-glass"></i>
                      <span class="d-none d-lg-inline">
                        {{ t('Search') }}
                      </span>
                    </button>
                    <button cButton class="btn btn-light text-danger mb-2" type="submit" (click)="cancelSearch()" *ngIf="formGroup.value.search" ><i class="fa-solid fa-circle-xmark"></i></button>
                  </c-col>

                  </form>

          </c-col>

          <c-col class="col-12 col-lg-6">

        <c-row class="justify-content-end align-items-center">

          <!-- View mode toggle -->
          <c-col xs="auto" class="mb-2">
            <div class="btn-group" role="group" aria-label="View mode">
              <button type="button" class="btn btn-sm" [class.btn-secondary]="viewMode === 'table'" [class.btn-outline-secondary]="viewMode !== 'table'" (click)="setViewMode('table')" title="{{ t('Table view') }}">
                <i class="fa-solid fa-table-list"></i>
              </button>
              <button type="button" class="btn btn-sm" [class.btn-secondary]="viewMode === 'cards'" [class.btn-outline-secondary]="viewMode !== 'cards'" (click)="setViewMode('cards')" title="{{ t('Card view') }}">
                <i class="fa-solid fa-grip"></i>
              </button>
            </div>
          </c-col>

          <c-col xs="auto" class="mb-2" *ngIf="pagination.totalPages > 1">
            <c-input-group  class="text-end">
              <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
              <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
                <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
              </select>
            </c-input-group>
          </c-col>
          <c-col xs="auto" class="mb-2">
            <c-input-group>
              <span cInputGroupText><svg cIcon class="me-2" name="cil-sort-ascending"></svg></span>
              <select aria-label="Default select example" (change)="updateFilter()" name="sort" cSelect [(ngModel)]="sort">
                <option value="newest">{{ t('Newest') }}</option>
                <option value="oldest">{{ t('Oldest') }}</option>
                <option value="name">{{ t('Name') }}</option>
              </select>
            </c-input-group>
          </c-col>
        </c-row>
      </c-col>
    </c-row>


    <!-- ═══════════════════════════════════════════
         TABLE VIEW
    ══════════════════════════════════════════════ -->
    <c-row *ngIf="groups && viewMode === 'table'">
      <c-col>

        <table
        [hover]="true"
        [responsive]="true"
        [striped]="true"
        align="middle"
        cTable
        class="mb-0 border groups-table"
        >
          <thead>
            <tr>
              <th scope="col" style="width:1%"></th>
              <th scope="col" style="width:1%"></th>
              <th scope="col">{{ t('Name') }}</th>
              <th scope="col" style="width:60px"># {{ t('Workers') }}</th>
              <th scope="col" class="col-workers">{{ t('Workers') }}</th>
              <th scope="col" class="col-monitors" *ngIf="hasAnyMonitors">{{ t('Monitors') }}</th>
              <th scope="col" *ngIf="okService.alert_loops.length > 0">{{ t('Alert Loop') }}</th>
              <th scope="col" *ngIf="okService.alert_loops.length > 0 && okService.settings.outhrs_on">{{ t('Out Hours Alert Loop') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let group of groups">
              <td>
                <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/group/{{group.id}}" *ngIf="okService.hasMonitorAccess('groups','view')">
                  <svg cIcon class="me-2" name="cil-pencil"></svg>
                  {{ t('Edit') }}
                </button>
              </td>
              <td>
                <button *ngIf="group.color" type="button" class="btn btn-secondary group-color" [style.background-color]="group.color">&nbsp;</button>
              </td>
              <td>
                <b class="fs-5">{{group.name}}</b>
              </td>
              <td class="text-center">
                <span class="badge bg-secondary">{{countWorkers(group.worker_ids)}}</span>
              </td>
              <!-- Workers chips -->
              <td class="col-workers">
                <div class="chips-wrap">
                  <span *ngFor="let name of workerPreview(group)" class="chip chip-worker">{{name}}</span>
                  <button *ngIf="workerOverflow(group) > 0 && !expandedWorkers.has(group.id)"
                    class="btn btn-link btn-sm chip-more p-0"
                    (click)="toggleWorkers(group.id, $event)">
                    +{{workerOverflow(group)}} {{ t('more') }}
                  </button>
                  <button *ngIf="expandedWorkers.has(group.id)"
                    class="btn btn-link btn-sm chip-more p-0"
                    (click)="toggleWorkers(group.id, $event)">
                    {{ t('Show less') }}
                  </button>
                </div>
              </td>
              <!-- Monitors chips — column hidden when no monitors on this page -->
              <td class="col-monitors" *ngIf="hasAnyMonitors">
                <div class="chips-wrap">
                  <span *ngFor="let name of monitorPreview(group)" class="chip chip-monitor">{{name}}</span>
                  <button *ngIf="monitorOverflow(group) > 0 && !expandedMonitors.has(group.id)"
                    class="btn btn-link btn-sm chip-more p-0"
                    (click)="toggleMonitors(group.id, $event)">
                    +{{monitorOverflow(group)}} {{ t('more') }}
                  </button>
                  <button *ngIf="expandedMonitors.has(group.id)"
                    class="btn btn-link btn-sm chip-more p-0"
                    (click)="toggleMonitors(group.id, $event)">
                    {{ t('Show less') }}
                  </button>
                </div>
              </td>
              <td *ngIf="okService.alert_loops.length > 0">
                {{group.alert_loop_name}}
              </td>
              <td *ngIf="okService.alert_loops.length > 0 && okService.settings.outhrs_on">
                {{group.alert_loop_oo_name}}
              </td>
            </tr>
          </tbody>
        </table>

      </c-col>
    </c-row>


    <!-- ═══════════════════════════════════════════
         CARD VIEW
    ══════════════════════════════════════════════ -->
    <c-row *ngIf="groups && viewMode === 'cards'" class="mt-3 g-3">
      <c-col class="col-12 col-sm-6 col-xl-4" *ngFor="let group of groups">
        <div class="group-card h-100">

          <!-- Card header -->
          <div class="group-card__header" [style.border-left-color]="group.color || '#6c757d'">
            <div class="d-flex align-items-center gap-2 flex-grow-1">
              <span *ngIf="group.color" class="group-color-dot" [style.background-color]="group.color"></span>
              <strong class="fs-6">{{group.name}}</strong>
            </div>
            <div class="d-flex align-items-center gap-2">
              <span class="badge bg-secondary" title="{{ t('Workers') }}">
                <i class="fa-solid fa-users me-1"></i>{{countWorkers(group.worker_ids)}}
              </span>
              <button *ngIf="okService.hasMonitorAccess('groups','view')" color="info" cButton class="btn-sm text-white" routerLink="/mgmt/group/{{group.id}}" (click)="$event.stopPropagation()">
                <svg cIcon name="cil-pencil"></svg>
              </button>
            </div>
          </div>

          <!-- Workers section -->
          <div class="group-card__body">
            <div class="group-card__section" *ngIf="toNameArray(group.worker_names).length > 0">
              <span class="group-card__label"><i class="fa-solid fa-users me-1"></i>{{ t('Workers') }}</span>
              <div class="chips-wrap">
                <span *ngFor="let name of workerPreview(group)" class="chip chip-worker">{{name}}</span>
                <button *ngIf="workerOverflow(group) > 0 && !expandedWorkers.has(group.id)"
                  class="btn btn-link btn-sm chip-more p-0"
                  (click)="toggleWorkers(group.id, $event)">
                  +{{workerOverflow(group)}} {{ t('more') }}
                </button>
                <button *ngIf="expandedWorkers.has(group.id)"
                  class="btn btn-link btn-sm chip-more p-0"
                  (click)="toggleWorkers(group.id, $event)">
                  {{ t('Show less') }}
                </button>
              </div>
            </div>

            <!-- Monitors section -->
            <div class="group-card__section" *ngIf="toNameArray(group.monitor_names).length > 0">
              <span class="group-card__label"><i class="fa-solid fa-shield-halved me-1"></i>{{ t('Monitors') }}</span>
              <div class="chips-wrap">
                <span *ngFor="let name of monitorPreview(group)" class="chip chip-monitor">{{name}}</span>
                <button *ngIf="monitorOverflow(group) > 0 && !expandedMonitors.has(group.id)"
                  class="btn btn-link btn-sm chip-more p-0"
                  (click)="toggleMonitors(group.id, $event)">
                  +{{monitorOverflow(group)}} {{ t('more') }}
                </button>
                <button *ngIf="expandedMonitors.has(group.id)"
                  class="btn btn-link btn-sm chip-more p-0"
                  (click)="toggleMonitors(group.id, $event)">
                  {{ t('Show less') }}
                </button>
              </div>
            </div>

            <!-- Alert loops -->
            <div class="group-card__section" *ngIf="okService.alert_loops.length > 0 && group.alert_loop_name">
              <span class="group-card__label"><i class="fa-solid fa-rotate me-1"></i>{{ t('Alert Loop') }}</span>
              <span class="small">{{group.alert_loop_name}}</span>
            </div>
            <div class="group-card__section" *ngIf="okService.alert_loops.length > 0 && okService.settings.outhrs_on && group.alert_loop_oo_name">
              <span class="group-card__label"><i class="fa-solid fa-moon me-1"></i>{{ t('Out Hours') }}</span>
              <span class="small">{{group.alert_loop_oo_name}}</span>
            </div>
          </div>

        </div>
      </c-col>
    </c-row>


    <!-- Bottom pagination -->
    <c-row class="justify-content-end" *ngIf="pagination.totalPages>1">
      <c-col xs="auto" class="mt-2" *ngIf="pagination.totalPages > 1">
        <c-input-group  class="text-end">
          <span cInputGroupText><i class="fa-solid fa-arrow-down-1-9"></i></span>
          <select aria-label="Default select example" name="page" cSelect (change)="updateFilter()"  [(ngModel)]="pagination.page">
            <option *ngFor="let p of pagination.pageArray" value="{{p}}">{{p}}</option>
          </select>
        </c-input-group>
      </c-col>
    </c-row>

  </c-card-body>
</c-card>
